import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '@/shared/components/Badge';
import { shiftBadgeLabel, shiftLevel } from '@/shared/utils/shift';
/**
 * Etiqueta del turno junto al nombre del alumno en los listados de permisos:
 * «Inicio» / «Avanzado» (niveles de Policía Local) o «A Distancia». Los turnos
 * sin nivel ni modalidad (p. ej. Policía Nacional) no muestran nada.
 */
export function StudentShiftBadge({ shiftName }) {
    const label = shiftBadgeLabel(shiftName);
    if (!label)
        return null;
    return _jsx(Badge, { variant: shiftLevel(shiftName) ? 'info' : 'default', children: label });
}
//# sourceMappingURL=StudentShiftBadge.js.map